var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconBoxplotMedian(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.38168 1.31906V2.21866H2.61835V1.31906C2.61835 0.901444 2.11345 0.692303 1.81814 0.987597L0.1373 2.66844C-0.0457666 2.85151 -0.0457666 3.14829 0.1373 3.33135L1.81814 5.0122C2.11343 5.30749 2.61835 5.09835 2.61835 4.68073V3.78116H7.38168V4.68075C7.38168 5.09837 7.88658 5.30751 8.18189 5.01222L9.86273 3.33137C10.0458 3.14831 10.0458 2.85153 9.86273 2.66846L8.18189 0.987616C7.8866 0.692303 7.38168 0.901444 7.38168 1.31906Z",
    fill: "#1E88E5"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBoxplotMedian);
export default __webpack_public_path__ + "static/media/icon_boxplot_median.65a0945f24c81bc40f63d43dbf8fc8de.svg";
export { ForwardRef as ReactComponent };